import * as Yup from 'yup';
import {
  personalDetails,
  addressDetails,
  confirmation,
  securityDetails,
  disqualification,
} from '@/utils/schemas/common';

const schema = {
  licence_status: Yup.string().when(['step'], {
    is: (step) => step === '1',
    then: Yup.string().required(`Licence Status is required`).nullable(),
  }),
  driver_number: Yup.string().when('step', {
    is: (value) => value === '1',
    then: Yup.string()
      .required(`Licence Number is required`)
      .min(16, 'Licence Number must be at least 16 characters')
      .max(16, 'Licence Number must not exceed 16 characters')
      .matches(/^[a-zA-Z0-9]*$/, 'No spaces or special characters are allowed'),
  }),

  ...disqualification,
  ...personalDetails,
  ...addressDetails,
  ...securityDetails,
  ...confirmation,
};

export const replacementSchema = Yup.object().shape(schema);
